import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  total_arrangement_rate: {
    name: "Total percentage of net asset value of the AIF's assets currently subject to special arrangements arising from their illiquid nature under FUND 3.2.5R, and see also Article 23(4) of the AIFMD, including those in 213",
    order: 214,
    letter: 'A'
  },
  investor_preferential_treatment_flag: {
    name: 'Are there any investors who obtain preferential treatment or the right to preferential treatment and therefore are subject to disclosure in accordance with FUND 3.2.2R(11), and see also Article 23(1)(j) of the AIFMD?',
    order: 215,
    letter: 'B'
  }
};

export function Arragements2({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT,
    onChangeFund,
    schema: schema.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT?.field_names ||
      [],
    columnLables,
    tableName: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT',
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="fca-reporttables-arrangements-2-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
